import axios from '../plugins/axios';
import {AxiosResponse} from "axios";

const resource = 'api/v1/referential_sticker';

export default {
    getReferentielStickerByIdProfessional(): Promise<AxiosResponse<IServerResponse<IReferentielSticker[]>>> {
        return axios.get(`${resource}/professional`);
    },
}